// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9fce6579","879":"c4e38b3f"}[chunkId] + ".chunk.js";
};